import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import vuetify from './plugins/vuetify';



import './assets/css/style.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

import * as echarts from 'echarts'
import { locale } from 'core-js'
Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
Vue.prototype.$axios = axios

Vue.filter('fixedDPR', function (value, type) {
  if(type && type != ''){
    return type + ":" + value/window.devicePixelRatio+"px";
  }else{
    return value/window.devicePixelRatio+"px";
  }
  
})
// 添加中英文切换
import VueI18n from 'vue-i18n';
import zh from './components/i18n/zh';
import en from './components/i18n/en';
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh:zh,
    en:en,
  }
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
